import { createFileRoute } from '@tanstack/react-router';
import {
  StudyDetailLayout,
  StudyErrorBoundary,
  studyDetailLoader,
  studyDetailSearchSchema,
} from './-components/StudyDetailLayout';

/**
 * The SimOps mounting of the study detail shell.
 *
 * Everything a reader sees lives in `StudyDetailLayout`, which `/evaltool/
 * $studyId` mounts as well: the same study, the same steps, addressed by the
 * product the reader is in. This file is the router-facing half — search
 * validation, the cache warm, the error boundary. Which library is live comes
 * from the path, not from here.
 */
function SimOpsStudyRoute() {
  const { studyId } = Route.useParams();
  const search = Route.useSearch();
  return <StudyDetailLayout studyId={studyId} search={search} />;
}

export const Route = createFileRoute('/_app/simops/$studyId')({
  validateSearch: studyDetailSearchSchema,
  loader: ({ context: { queryClient }, params: { studyId } }) =>
    studyDetailLoader({ queryClient, studyId }),
  component: SimOpsStudyRoute,
  errorComponent: StudyErrorBoundary,
});
